export default __webpack_public_path__ + "static/media/statisticsIcon.b98ea653.svg";